var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

if (!iOS && $(window).width() <= 1024) {
	$('input[type=text],input[type=email],textarea,select').on('focusin', function () {
		$('header').addClass("visually-hidden");
	});

	$('input[type=text],input[type=email],textarea,select').on('focusout', function () {
		$('header').removeClass("visually-hidden");
	});
}